import { Code, ExamField as EMF, Title } from 'constants/codes';
import { Utility } from 'helpers/UtilityHelpers';
import { CommonDataColumn, OptionType, PrescriptionData, MedicationData } from 'models/BaseModel';


export enum ExamMap {
    FINALRX = 1,
    FINALRX2 = 2,
    MEDICATION = 3,
    CLTRAIL = 4,
    CLTRAIL2 = 5,
    CLFINAL = 6,
  }

export const getLabel = (value: number, options: OptionType[]): string => {
    const found = options.find(option => option.value=== value);
    return found?.label? found.label : "";
  };

export  const handleGetTime = (
  setExamData?: React.Dispatch<React.SetStateAction<Record<string, any>>>
  ) => (e: React.FocusEvent<HTMLInputElement>) => {
    let { id, value } = e.target;

    //console.log("handleDropsTime: ", id, value);
    if (!value) {
      if (typeof setExamData === "function") {
        setExamData(prev => ({
          ...prev,
          [id]: Utility.Format.Date(new Date(), Code.Format.DateTime.TimeTT),
        }));
      }
    }
  };

export const handleCopyAll = () => {
  let copyData = "";
  Code.Exam.FieldGroup.AllFields.forEach((field, index) => {
    const inputElement = document.getElementById(field) as HTMLInputElement | null;
    if (inputElement?.value) {
      copyData += `${field}::${inputElement.value};;`;
    }
  });
  navigator.clipboard.writeText(btoa(copyData));
};

export const handlePasteVisible = () => {
  const input = document.getElementById('T14');
  if (input && isElementInViewport(input)) {
    console.log('Input is visible in viewport');
  }
  else{ console.log('not visisble');}
};

export const handlePasteAll = async (
  setExamData?: React.Dispatch<React.SetStateAction<Record<string, any>>>
  ) => {
    let data = await navigator.clipboard.readText();
    if (!data) return;
    if (!setExamData) return;
    
    if (!/^[A-Za-z0-9+/=]+$/.test(data)) {
      //console.log("Clipboard data is not valid Base64.");
      return;
    }

    data = atob(data);

    console.clear();
    //console.log(data)
    
    if(!data.includes("::") || !data.includes(";;")) return;

    var exclude = Code.Exam.FieldGroup.ExcludeFields;

    const entries = data.split(";;").filter(Boolean); 
    if (entries.length === 0) return;

    const userName = Utility.Storage.UserName();
    
    setExamData((prev) => {
      const updated = { ...prev };

      entries.forEach((entry) => {
        const [key, value] = entry.split("::");
        if (!key || value == null) return;

        if (exclude.includes(key)) return;

        const current = (updated as Record<string, string | null | undefined>)[key];

        if (current === '' || current === undefined || current === null) {
          (updated as Record<string, string | null | undefined>)[key] = value;
        }
      });

      updateExamDate(updated,Code.Exam.FieldGroup.Complaint,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Ocular,userName); 
      updateExamDate(updated,Code.Exam.FieldGroup.Medical,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Unaided,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Aided,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Pupils,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Fields,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.CoverTest,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.ColorVision,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.ColorVision2,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Stereopsis,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Additional,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Binocular,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Retino,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Amplitude,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Drops,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Anterior,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Puncta,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Posterior,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Gonioscopy,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Fields2,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Prescription,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Medications,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.MedicationFull,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Diagnosis,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Habitual,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Habitual2,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Tonometry,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Tonometry2,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Over,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Keratom,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Pachymetry,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Subjective,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Autorefraction,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.FinalAdd,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Balance,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.FinalRx,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.FinalRx2,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Cycloplegic,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Pd,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Other,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.CLTrial,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.CLTrial2,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.CLFinal,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.AnteriorCL,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.ContactLens,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.PosteriorPhoto,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Eom,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Prelims,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Npc,userName);
      updateExamDate(updated,Code.Exam.FieldGroup.Bcc,userName);


      return updated;
    });
  };

  export const handleIntakeAll = async (
  setFormData?: React.Dispatch<React.SetStateAction<Record<string, any>>>
  ) => {
    let data = await navigator.clipboard.readText();

    if (!data) return;
    if (!setFormData) return;
    
    if (!/^[A-Za-z0-9+/=]+$/.test(data)) {
      //console.log("Clipboard data is not valid Base64.");
      return;
    }

    data = atob(data);

    console.clear();
    //console.log(data)
    
    if(!data.includes("::") || !data.includes(";;")) return;

    const entries = data.split(";;").filter(Boolean); 
    if (entries.length === 0) return;

    setFormData((prev) => {
      const updated = { ...prev };

      entries.forEach((entry) => {
        const [key, value] = entry.split("::");
        if (!key || value == null) return;

        const current = (updated as Record<string, string | null | undefined>)[key];

        if (current === '' || current === undefined || current === null) {
          (updated as Record<string, string | null | undefined>)[key] = value;
        }
      });

      //console.log("----->",updated);

      return updated;
    });
  };

  function updateExamDate(
    updated: Record<string, string>,
    fieldList: string[],
    userName: string
  ): void {
    fieldList.forEach((field, index) => {
      if (index >  0 && updated[field] && updated[field] !=='') {
        updated[fieldList[0]] = userName + ' ' + Utility.Format.Date(new Date(), Code.Format.DateTime.Full);
        return;
      }
    });
  }

const isElementInViewport = (el: HTMLElement): boolean => {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

export const mapMedication = (
    examData: CommonDataColumn | null
  ): MedicationData | null => {
    if (!examData) return null;

    //console.log("mapRxData: ", examData);

    const mData: MedicationData = {
      Medication1: examData[EMF.Prescription.Medication1] ?? undefined, 
      Frequency1: examData[EMF.Prescription.Frequency1] ?? undefined, 
      Refills1: examData[EMF.Prescription.Refills1] ?? undefined, 
      Remarks1:examData[EMF.Prescription.Remarks1] ?? undefined, 
      Check1:examData[EMF.Prescription.Check1] ?? undefined, 

      Medication2: examData[EMF.Prescription.Medication2] ?? undefined, 
      Frequency2: examData[EMF.Prescription.Frequency2] ?? undefined, 
      Refills2: examData[EMF.Prescription.Refills2] ?? undefined, 
      Remarks2:examData[EMF.Prescription.Remarks2] ?? undefined,
      Check2:examData[EMF.Prescription.Check2] ?? undefined, 

      Medication3: examData[EMF.Prescription.Medication3] ?? undefined, 
      Frequency3: examData[EMF.Prescription.Frequency3] ?? undefined, 
      Refills3: examData[EMF.Prescription.Refills3] ?? undefined, 
      Remarks3:examData[EMF.Prescription.Remarks3] ?? undefined,
      Check3:examData[EMF.Prescription.Check3] ?? undefined, 
      
      Medication4: examData[EMF.Prescription.Medication4] ?? undefined, 
      Frequency4: examData[EMF.Prescription.Frequency4] ?? undefined, 
      Refills4: examData[EMF.Prescription.Refills4] ?? undefined, 
      Remarks4:examData[EMF.Prescription.Remarks4] ?? undefined,
      Check4:examData[EMF.Prescription.Check4] ?? undefined, 
      
      Medication5: examData[EMF.Prescription.Medication5] ?? undefined, 
      Frequency5: examData[EMF.Prescription.Frequency5] ?? undefined, 
      Refills5: examData[EMF.Prescription.Refills5] ?? undefined, 
      Remarks5:examData[EMF.Prescription.Remarks5] ?? undefined,
      Check5:examData[EMF.Prescription.Check5] ?? undefined, 
      
      Medication6: examData[EMF.Prescription.Medication6] ?? undefined, 
      Frequency6: examData[EMF.Prescription.Frequency6] ?? undefined, 
      Refills6: examData[EMF.Prescription.Refills6] ?? undefined, 
      Remarks6:examData[EMF.Prescription.Remarks6] ?? undefined,
      Check6:examData[EMF.Prescription.Check6] ?? undefined, 
      
      Medication7: examData[EMF.Prescription.Medication7] ?? undefined, 
      Frequency7: examData[EMF.Prescription.Frequency7] ?? undefined, 
      Refills7: examData[EMF.Prescription.Refills7] ?? undefined, 
      Remarks7:examData[EMF.Prescription.Remarks7] ?? undefined,
      Check7:examData[EMF.Prescription.Check7] ?? undefined, 
      
      Medication8: examData[EMF.Prescription.Medication8] ?? undefined, 
      Frequency8: examData[EMF.Prescription.Frequency8] ?? undefined, 
      Refills8: examData[EMF.Prescription.Refills8] ?? undefined, 
      Remarks8:examData[EMF.Prescription.Remarks8] ?? undefined,
      Check8:examData[EMF.Prescription.Check8] ?? undefined, 

      Notes: examData[EMF.Prescription.Notes] ?? undefined,
    };

    //console.log("mapMedication-------->: ", mData);

    return mData;
  };

export const mapRxData = (
    examData: CommonDataColumn | null, 
    examMap: ExamMap
  ): PrescriptionData | null => {
    if (!examData) return null;

    //console.log("mapRxData: ", examData);

    let pData: PrescriptionData = {};
  
    if(examMap === ExamMap.FINALRX) {
      pData = {
        ODSphere: examData[EMF.FinalRx.ODSphere] ?? undefined, 
        OSSphere: examData[EMF.FinalRx.OSSphere] ?? undefined, 
        ODCylinder: examData[EMF.FinalRx.ODCylinder] ?? undefined, 
        OSCylinder:examData[EMF.FinalRx.OSCylinder] ?? undefined, 
        ODAxis: examData[EMF.FinalRx.ODAxis] ?? undefined, 
        OSAxis: examData[EMF.FinalRx.OSAxis] ?? undefined, 
        ODAdd: examData[EMF.FinalRx.ODAdd] ?? undefined, 
        OSAdd: examData[EMF.FinalRx.OSAdd] ?? undefined, 
        RXNotes: examData[EMF.FinalRx.Notes] ?? undefined,
        data1: examData[EMF.FinalRx.Lens] ?? undefined,
        data2: examData[EMF.FinalRx.MatteTinted] ?? undefined,
      };
      AddTitleValues(pData, "Prism", examData[EMF.FinalRx.ODPrism], examData[EMF.FinalRx.OSPrism]);
      AddTitleValues(pData, "Orient", examData[EMF.FinalRx.ODOrient], examData[EMF.FinalRx.OSOrient]);
      AddTitleValues(pData, "Prism 2", examData[EMF.FinalRx.ODPrism2], examData[EMF.FinalRx.OSPrism2]);
      AddTitleValues(pData, "Orient 2", examData[EMF.FinalRx.ODOrient2], examData[EMF.FinalRx.OSOrient2]);
      AddTitleValues(pData, "PD", examData[EMF.FinalRx.ODPd], examData[EMF.FinalRx.OSPd]);
      AddTitleValues(pData, "Acuity", examData[EMF.FinalRx.ODAcuity], examData[EMF.FinalRx.OSAcuity]);
    }
    else if(examMap === ExamMap.FINALRX2) {
      pData = {
        ODSphere: examData[EMF.FinalRx2.ODSphere] ?? undefined, 
        OSSphere: examData[EMF.FinalRx2.OSSphere] ?? undefined, 
        ODCylinder: examData[EMF.FinalRx2.ODCylinder] ?? undefined, 
        OSCylinder:examData[EMF.FinalRx2.OSCylinder] ?? undefined, 
        ODAxis: examData[EMF.FinalRx2.ODAxis] ?? undefined, 
        OSAxis: examData[EMF.FinalRx2.OSAxis] ?? undefined, 
        ODAdd: examData[EMF.FinalRx2.ODAdd] ?? undefined, 
        OSAdd: examData[EMF.FinalRx2.OSAdd] ?? undefined, 
        RXNotes: examData[EMF.FinalRx2.Notes] ?? undefined,
        data1: examData[EMF.FinalRx2.Lens] ?? undefined,
        data2: examData[EMF.FinalRx2.MatteTinted] ?? undefined,
      };
      AddTitleValues(pData, "Prism", examData[EMF.FinalRx2.ODPrism], examData[EMF.FinalRx2.OSPrism]);
      AddTitleValues(pData, "Orient", examData[EMF.FinalRx2.ODOrient], examData[EMF.FinalRx2.OSOrient]);
      AddTitleValues(pData, "Prism 2", examData[EMF.FinalRx2.ODPrism2], examData[EMF.FinalRx2.OSPrism2]);
      AddTitleValues(pData, "Orient 2", examData[EMF.FinalRx2.ODOrient2], examData[EMF.FinalRx2.OSOrient2]);
      AddTitleValues(pData, "PD", examData[EMF.FinalRx2.ODPd], examData[EMF.FinalRx2.OSPd]);
      AddTitleValues(pData, "Acuity", examData[EMF.FinalRx2.ODAcuity], examData[EMF.FinalRx2.OSAcuity]);
    }
    else if(examMap === ExamMap.CLTRAIL) {
      pData = {
        ODBc: examData[EMF.CLTrial.ODBc] ?? undefined, 
        OSBc: examData[EMF.CLTrial.OSBc] ?? undefined, 
        ODDia: examData[EMF.CLTrial.ODDia] ?? undefined, 
        OSDia: examData[EMF.CLTrial.OSDia] ?? undefined, 
        ODSphere: examData[EMF.CLTrial.ODSphere] ?? undefined, 
        OSSphere: examData[EMF.CLTrial.OSSphere] ?? undefined, 
        ODCylinder: examData[EMF.CLTrial.ODCylinder] ?? undefined, 
        OSCylinder:examData[EMF.CLTrial.OSCylinder] ?? undefined, 
        ODAxis: examData[EMF.CLTrial.ODAxis] ?? undefined, 
        OSAxis: examData[EMF.CLTrial.OSAxis] ?? undefined, 
        ODAdd: examData[EMF.CLTrial.ODAdd] ?? undefined, 
        OSAdd: examData[EMF.CLTrial.OSAdd] ?? undefined, 
        ODSupplier: examData[EMF.CLTrial.ODSupplier] ?? undefined, 
        OSSupplier: examData[EMF.CLTrial.OSSupplier] ?? undefined, 
        ODType: examData[EMF.CLTrial.ODType] ?? undefined, 
        OSType: examData[EMF.CLTrial.OSType] ?? undefined, 
        ODName: examData[EMF.CLTrial.ODName] ?? undefined, 
        OSName: examData[EMF.CLTrial.OSName] ?? undefined, 
        ODColor: examData[EMF.CLTrial.ODColor] ?? undefined, 
        OSColor: examData[EMF.CLTrial.OSColor] ?? undefined, 
        RXNotes: examData[EMF.CLTrial.FittingNote] ?? undefined,
        data1: examData[EMF.CLTrial.Status] ?? undefined,
      };
    }
    else if(examMap === ExamMap.CLTRAIL2) {
      pData = {
        ODBc: examData[EMF.CLTrial2.ODBc] ?? undefined, 
        OSBc: examData[EMF.CLTrial2.OSBc] ?? undefined, 
        ODDia: examData[EMF.CLTrial2.ODDia] ?? undefined, 
        OSDia: examData[EMF.CLTrial2.OSDia] ?? undefined, 
        ODSphere: examData[EMF.CLTrial2.ODSphere] ?? undefined, 
        OSSphere: examData[EMF.CLTrial2.OSSphere] ?? undefined, 
        ODCylinder: examData[EMF.CLTrial2.ODCylinder] ?? undefined, 
        OSCylinder:examData[EMF.CLTrial2.OSCylinder] ?? undefined, 
        ODAxis: examData[EMF.CLTrial2.ODAxis] ?? undefined, 
        OSAxis: examData[EMF.CLTrial2.OSAxis] ?? undefined, 
        ODAdd: examData[EMF.CLTrial2.ODAdd] ?? undefined, 
        OSAdd: examData[EMF.CLTrial2.OSAdd] ?? undefined, 
        ODSupplier: examData[EMF.CLTrial2.ODSupplier] ?? undefined, 
        OSSupplier: examData[EMF.CLTrial2.OSSupplier] ?? undefined, 
        ODType: examData[EMF.CLTrial2.ODType] ?? undefined, 
        OSType: examData[EMF.CLTrial2.OSType] ?? undefined, 
        ODName: examData[EMF.CLTrial2.ODName] ?? undefined, 
        OSName: examData[EMF.CLTrial2.OSName] ?? undefined, 
        ODColor: examData[EMF.CLTrial2.ODColor] ?? undefined, 
        OSColor: examData[EMF.CLTrial2.OSColor] ?? undefined, 
        RXNotes: examData[EMF.CLTrial2.FittingNote] ?? undefined,
        data1: examData[EMF.CLTrial2.Status] ?? undefined,
      };
    }
    else if(examMap === ExamMap.CLFINAL) {
      pData = {
        ODBc: examData[EMF.CLFinal.ODBc] ?? undefined, 
        OSBc: examData[EMF.CLFinal.OSBc] ?? undefined, 
        ODDia: examData[EMF.CLFinal.ODDia] ?? undefined, 
        OSDia: examData[EMF.CLFinal.OSDia] ?? undefined, 
        ODSphere: examData[EMF.CLFinal.ODSphere] ?? undefined, 
        OSSphere: examData[EMF.CLFinal.OSSphere] ?? undefined, 
        ODCylinder: examData[EMF.CLFinal.ODCylinder] ?? undefined, 
        OSCylinder:examData[EMF.CLFinal.OSCylinder] ?? undefined, 
        ODAxis: examData[EMF.CLFinal.ODAxis] ?? undefined, 
        OSAxis: examData[EMF.CLFinal.OSAxis] ?? undefined, 
        ODAdd: examData[EMF.CLFinal.ODAdd] ?? undefined, 
        OSAdd: examData[EMF.CLFinal.OSAdd] ?? undefined, 
        ODSupplier: examData[EMF.CLFinal.ODSupplier] ?? undefined, 
        OSSupplier: examData[EMF.CLFinal.OSSupplier] ?? undefined, 
        ODType: examData[EMF.CLFinal.ODType] ?? undefined, 
        OSType: examData[EMF.CLFinal.OSType] ?? undefined, 
        ODName: examData[EMF.CLFinal.ODName] ?? undefined, 
        OSName: examData[EMF.CLFinal.OSName] ?? undefined, 
        ODColor: examData[EMF.CLFinal.ODColor] ?? undefined, 
        OSColor: examData[EMF.CLFinal.OSColor] ?? undefined, 
        RXNotes: examData[EMF.CLFinal.FittingNote] ?? undefined,
        data1: examData[EMF.CLFinal.Status] ?? undefined,
      };
    }

    return pData;
  };

const AddTitleValues = (
  pData: PrescriptionData,
  Title: string,
  ODValue: string | null | undefined,
  OSValue: string | null | undefined,
): void => {
  if (!(ODValue?.trim() || OSValue?.trim())) return;

  for (let i = 1; i <= 12; i++) {
    const titleKey = `Title${i}` as keyof PrescriptionData;
    const odKey = `ODValue${i}` as keyof PrescriptionData;
    const osKey = `OSValue${i}` as keyof PrescriptionData;

    if (!pData[titleKey]) {
      pData[titleKey] = Title ?? '';
      pData[odKey] = ODValue ?? '';
      pData[osKey] = OSValue ?? '';
      break;
    }
  }
};
  